const en = {
    name: 'Name',
    category: 'Category',
    condition: 'Condition',
    price: 'Price',
    city: 'City',
    addDescription: 'Add description',
    seeAllUserAds: 'See all user ads',
    description: 'Description',
    seller: 'Seller',
    btn: {
        deleteBtn: 'Delete ad',
        deleteFromFavBtn: 'Delete from favorites',
        addToFavBtn: 'Add to favorites',
        writeAMessageBtn: 'Write a message',
        messageTheSellerOnTelegram: 'Message the seller on Telegram'
    }
}

const rus = {
    name: 'Название',
    category: 'Категория',
    condition: 'Состояние',
    price: 'Цена',
    city: 'Город',
    addDescription: 'Добавить описание',
    seeAllUserAds: 'Посмотреть все объявления продавца',
    description: 'Описание',
    seller: 'Продавец',
    btn: {
        deleteBtn: 'Удалить',
        deleteFromFavBtn: 'Удалить из избранного',
        addToFavBtn: 'Добавить в избранное',
        writeAMessageBtn: 'Написать сообщение',
        messageTheSellerOnTelegram: 'Написать  продавцу в телеграме'
    }
}

const hebrew = {
    name: 'כותרת',
    category: 'קטגוריה',
    condition: 'מצב',
    price: 'מחיר',
    city: 'עיר',
    addDescription: 'הוסף תיאור',
    seeAllUserAds: 'צפה בכל המודעות של המוכר',
    description: 'תיאור',
    seller: 'מוכר',
    
    btn: {
        deleteBtn: 'מחק',
        deleteFromFavBtn: 'הסר מהמועדפים',
        addToFavBtn: 'הוסף למועדפים',
        writeAMessageBtn: 'כתוב הודעה',
        messageTheSellerOnTelegram: 'כתוב למוכר בטלגרם'
    }
}

const choose = { en, rus, hebrew };

export default choose;                           